export const getPersistedLinkStateLabel = (isActive) => (isActive ? 'Активне' : 'Неактивне')

export const getDraftLinkStateLabel = (isActive) =>
  isActive ? 'Активне після створення' : 'Неактивне після створення'

export const UTM_PREVIEW_PLACEHOLDER = {
  incompleteUtm: 'Буде доступне після заповнення полів',
  incompleteShortNoTitle: 'Попередній slug буде доступний після заповнення назви',
  incompleteShort: 'Буде створено після збереження',
  invalidUtm: 'UTM не згенеровано через некоректну комбінацію.',
  invalidShort: 'Коротке посилання буде доступне після виправлення комбінації.',
  ownerEmpty: 'Не обрано',
}
